import React from 'react';
import PropTypes from 'prop-types';
import { Alert} from 'react-bootstrap';
/**
* @desc  Email verification form with the code
* @version 1.0.1
* @author  Lakshmikanth,Amrutha KK
*/

class EmailVerificationForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      error: props.error,
      verificationCode: '',
    };
  }
/**
 * @desc Save the verification code field
 * @param event
 * @return null
 */
  onSubmit = (event) => {
    event.preventDefault();
    this.props.onSubmit(this.state.verificationCode.trim());
  }
/**
 * @desc Fill the verification code field
 * @param event
 * @return null
 */
  changeVerificationCode = (event) => {
    this.setState({ verificationCode: event.target.value });
  }

  render = () => (
    <form onSubmit={this.onSubmit}>
      <Alert bsStyle="danger" className="error-message">{this.props.error}</Alert>
      <label>
        Verification Code
        <input placeholder="code" onChange={this.changeVerificationCode} required />
      </label>
      <button type="submit">Submit</button>
      <button type="button" onClick={this.props.onCancel}>Cancel</button>
    </form>
  )
}
EmailVerificationForm.propTypes = {
  onSubmit: PropTypes.func,
  onCancel: PropTypes.func,
  error: PropTypes.string,
};

export default EmailVerificationForm;



// WEBPACK FOOTER //
// ./src/components/Authentication/EmailVerificationForm.js